export enum MonthOptionEnum {
    MOST_RECENT = 'MOST_RECENT',
    M1 = 'M1',
    M2 = 'M2',
    M3 = 'M3',
    M4 = 'M4',
    M5 = 'M5',
    M6 = 'M6',
    M7 = 'M7',
    M8 = 'M8',
    M9 = 'M9',
    M10 = 'M10',
    M11 = 'M11',
    M12 = 'M12',
}

export const monthOptionLocalizationKeys: Record<MonthOptionEnum, string> = {
    [MonthOptionEnum.MOST_RECENT]: 'Briefing.onlineBriefing.settings.dateRange.mostRecentMonth',
    [MonthOptionEnum.M1]: 'Briefing.onlineBriefing.settings.dateRange.m1',
    [MonthOptionEnum.M2]: 'Briefing.onlineBriefing.settings.dateRange.m2',
    [MonthOptionEnum.M3]: 'Briefing.onlineBriefing.settings.dateRange.m3',
    [MonthOptionEnum.M4]: 'Briefing.onlineBriefing.settings.dateRange.m4',
    [MonthOptionEnum.M5]: 'Briefing.onlineBriefing.settings.dateRange.m5',
    [MonthOptionEnum.M6]: 'Briefing.onlineBriefing.settings.dateRange.m6',
    [MonthOptionEnum.M7]: 'Briefing.onlineBriefing.settings.dateRange.m7',
    [MonthOptionEnum.M8]: 'Briefing.onlineBriefing.settings.dateRange.m8',
    [MonthOptionEnum.M9]: 'Briefing.onlineBriefing.settings.dateRange.m9',
    [MonthOptionEnum.M10]: 'Briefing.onlineBriefing.settings.dateRange.m10',
    [MonthOptionEnum.M11]: 'Briefing.onlineBriefing.settings.dateRange.m11',
    [MonthOptionEnum.M12]: 'Briefing.onlineBriefing.settings.dateRange.m12',
};

/**
 * Carries the user's monthly date-range selection between a parent component and the
 * MonitoringSourcePicker (facet + search) variant that renders the monthly date-range UI.
 *
 * Stores the raw selected values (not dropdown option models) so it serializes cleanly into the
 * online-briefing preview config JSON. The picker maps these values to/from its dropdown options.
 */
export class MonthlyDateRangeSettingsModel {
    isCalendarMonths: boolean = true;
    selectedMonth: MonthOptionEnum | null = null;
    selectedYear: string | null = null;
}
